<p-fluid>
  <div
    [class.xofmanyrequired]="
      parentForm()?.errors?.xofmanyrequired && isOneOfManyRequired()
    "
    class="w-100"
  >
    <p-autoComplete
      [(ngModel)]="selectedLot"
      #lotSelection="ngModel"
      name="lotSelection"
      optionLabel="displayText"
      [suggestions]="lotSuggestions"
      (completeMethod)="onComplete($event)"
      (onDropdownClick)="onDropdownClick()"
      size="30"
      emptyMessage="No Lots"
      [dropdown]="true"
      [forceSelection]="forceSelection()"
      [placeholder]="placeholder()"
      (onSelect)="onChange()"
      (onClear)="clearLot()"
      [disabled]="disabled"
      [required]="required()"
      appendTo="body"
    />
  </div>
  <error-message [errorControl]="lotSelection">
    @if (lotSelection?.errors?.required) {
      <span>Please select at least one lot to continue.</span>
    }
  </error-message>
</p-fluid>
